<template>
  <section class="profile">
    <div v-if="profile" class="container-fluid p33" style="margin-top: 50px;">
      <div class="row">
        <div class="col-md-3 p0">
          <profile-card
          />
        </div>
        <div v-if="profile != null" class="col-md-9 pl20">
          <b-tabs
            defaultActiveKey="profile"
            content-class="mt-3"
            @activate-tab="handleActivateTab"
          >
            <b-tab
              v-for="(aSection, index) in sectionsValid"
              :key="index"
              :title="aSection.title"
            >
              <div v-if="false" :id="aSection.id" style="width: 10px">
                *
              </div>
              <component
                :is="aSection.component"
                v-bind="Object.assign({}, propsData)"
                :ref="aSection.componentName"
              >
              </component>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <v-tour name="myProfileTour" :steps="steps" :callbacks="handleCallbacks" />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import ProfileCard from "./profileCard";
import Apps from "./apps/index";
import Family from "./family/index";
import Settings from "./settings/index";
import SocialInfo from "./socialInfo/index";
import Profileinfo from "./profileInfo/index";
import Notifications from "./notifications/index";
import Connections from "./connections/index";
import Accounts from "./accounts/index";
import HeartBeat from "./heartbeat/index";
import HealthProfile from "./healthProfile/index";

//Tour
import VueTour from "vue-tour";
Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

export default {
  name: "Me_Profile",
  components: {
    ProfileCard
  },
  created() {
    this.getProfile();
  },
  mounted() {
    this.$tours["myProfileTour"].start();
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    sectionsValid() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile
      };
    },
    sections() {
      return [
        {
          title: "Basic Info",
          id: "v-info-step",
          component: Profileinfo,
          componentName: "Profileinfo",
          avail: true
        },
        {
          title: "Settings",
          id: "v-settings-step",
          component: Settings,
          componentName: "Settings",
          avail: true
        },
        {
          title: "Family",
          id: "v-family-step",
          component: Family,
          componentName: "Family",
          avail: true
        },
        {
          title: "MyApps",
          id: "v-myapps-step",
          component: Apps,
          componentName: "Apps",
          avail: true
        },
        {
          title: "Health Profile",
          id: "v-health-step",
          component: HealthProfile,
          componentName: "HealthProfile",
          avail: true
          //avail:  this.profile && this.profile.healthProfile ? true : false
        },
        {
          title: "💛 HeartBeat",
          id: "v-heartbeat-step",
          component: HeartBeat,
          componentName: "HeartBeat",
          avail: this.profile && this.profile.heartbeat ? true : false
        },
        {
          title: "Social Networks" /* Does not actually function- placeholder*/,
          id: "v-social-step",
          component: SocialInfo,
          componentName: "SocialInfo",
          avail: false
        },
        {
          title: "Connections",
          id: "v-connection-step",
          component: Connections,
          componentName: "Connections",
          avail: false
        },
        {
          title: "Notifications",
          id: "v-notifications-step",
          component: Notifications,
          componentName: "Notifications",
          avail: true
        },
        {
          title: "Accounts",
          id: "v-accounts-step",
          component: Accounts,
          componentName: "Accounts",
          avail: true
        }
      ];
    }
  },
  watch: {
    profile(val) {
      if (this.settings && this.settings.isAvail) {
        this.settings.avail = this.profile.heartbeat ? true : false;
      }
      return val;
    }
  },
  methods: {
    getProfile() {
      this.$nprogress.start();
      this.$store
        .dispatch("user/getProfile")
        .then(() => {
          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    handleActivateTab(tabIdx) {
      debugger;
      let refName = this.sectionsValid[tabIdx].componentName;

      let theComponents = this.$refs[refName];
      if (theComponents[0].hasOwnProperty("handleActivation")) {
        theComponents[0].handleActivation();
      }
    },
    handleTourCallbackOnStart(currentStep) {
      //Google Analytics
    },
    handleTourCallbackOnPreviousStep(currentStep) {
      //Google Analytics
    },
    handleTourCallbackOnNextStep(currentStep) {
      //Google Analytics
    },
    handleTourCallbackOnSkip(currentStep) {
      //Google Analytics
    },
    handleTourCallbackOnFinish(currentStep) {
      //Google Analytics
    },
    handleTourCallbackOnStop(currentStep) {
      //Google Analytics
    }
  },
  data() {
    return {
      steps: [
        {
          target: "#v-info-step", // We're using document.querySelector() under the hood
          content: `This is the Basic Info- where you can update all your infoDiscover <strong>Vue Tour</strong>!`
        },
        {
          target: "#v-myapps-step", // We're using document.querySelector() under the hood
          content: `<strong>MyApps</strong> are powerful! Add them here`
        },
        {
          target: "#v-family-step", // We're using document.querySelector() under the hood
          content: `<strong>Family</strong> add every family member here`
        },
        {
          target: "#v-settings-step", // We're using document.querySelector() under the hood
          content: `<strong>Settings</strong> modify your general settings for the app`
        },
        {
          target: "#v-heartbeat-step", // We're using document.querySelector() under the hood
          content: `<strong>HeartBeatCentral</strong> add every family member here`
        },
        {
          target: "#v-notifications-step", // We're using document.querySelector() under the hood
          content: `<strong>Notifications</strong> add every family member here`
        },
        {
          target: ".v-step-1",
          content: "An awesome plugin made with Vue.js!"
        },
        {
          target: '[data-v-step="2"]',
          content:
            "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
          params: {
            placement: "top"
          }
        }
      ],
      handleCallbacks: {
        onStart: this.handleTourCallbackOnStart(),
        onPreviousStep: this.handleTourCallbackOnPreviousStep(),
        onNextStep: this.handleTourCallbackOnNextStep(),
        onSkip: this.handleTourCallbackOnSkip(),
        onFinish: this.handleTourCallbackOnFinish(),
        onStop: this.handleTourCallbackOnStop()
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.profile {
  margin-top: 32px;
}

@media (min-width: 767px) {
  .p33 {
    // padding: 0 33px !important;
    width: 92% !important;
  }
}
@media (min-width: 767px) {
  .p33 {
    // padding: 0 33px !important;
    width: 92% !important;
  }
  .pl20 {
    padding: 0 20px;
    padding-left: 30px;
  }
  .p0 {
    padding: 0 !important;
  }
}
</style>
